import { Footer } from 'modules/Footer'
import { Header } from 'modules/Header'
import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'

export const Layout = () => {
  return (
    <>
      <Header />
      <main style={{ minHeight: '100dvh' }}>
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </>
  )
}
